import CryptoJS from 'crypto-js';

// กำหนดคีย์ลับสำหรับการเข้ารหัส (ในการใช้งานจริงควรเก็บไว้ใน environment variable)
const SECRET_KEY = 'khaya-backoffice-secret-key';

/**
 * เข้ารหัสข้อมูลด้วย AES
 * @param data ข้อมูลที่ต้องการเข้ารหัส
 * @returns string ข้อมูลที่ถูกเข้ารหัสแล้ว
 */
export const encrypt = (data: string): string => {
  try {
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
};

/**
 * ถอดรหัสข้อมูล AES
 * @param encryptedData ข้อมูลที่ถูกเข้ารหัส
 * @returns string ข้อมูลที่ถูกถอดรหัสแล้ว
 */
export const decrypt = (encryptedData: string): string => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return '';
  }
};

/**
 * เก็บข้อมูลที่เข้ารหัสแล้วใน localStorage
 */
export const setSecureItem = (key: string, value: string): void => {
  const encryptedValue = encrypt(value);
  localStorage.setItem(key, encryptedValue);
};

/**
 * ดึงและถอดรหัสข้อมูลจาก localStorage
 */
export const getSecureItem = (key: string): string | null => {
  const encryptedValue = localStorage.getItem(key);
  if (!encryptedValue) return null;

  const decryptedValue = decrypt(encryptedValue);
  return decryptedValue || null;
};
